import { j as s } from "../../../_virtual/jsx-runtime.js";
import t from "../../atoms/Button/index.js";
import i from "../../atoms/NotificationTooltip/index.js";
const n = ({
  confirmationMessage: e,
  cancelBtnProps: o,
  confirmBtnProps: m
}) => /* @__PURE__ */ s.jsxs(i, { className: "py-6 px-4", children: [
  /* @__PURE__ */ s.jsx("p", { className: "text-sm mt-4", children: e }),
  /* @__PURE__ */ s.jsxs("div", { className: "mt-6 flex gap-14", children: [
    /* @__PURE__ */ s.jsx(
      t,
      {
        bgColor: "white",
        size: "sm",
        isRounded: !0,
        className: "font-medium",
        ...o
      }
    ),
    /* @__PURE__ */ s.jsx(
      t,
      {
        size: "sm",
        isRounded: !0,
        className: "font-medium",
        ...m
      }
    )
  ] })
] });
export {
  n as default
};
